<script lang="ts">
	import BaseAdminLayout from './BaseAdminLayout.svelte';
	import type { User } from '$lib/shared/lib/types';

	interface Props {
		user: User | null;
		children?: import('svelte').Snippet;
	}

	let { user, children }: Props = $props();
</script>

<BaseAdminLayout {user}>
	{@render children?.()}
</BaseAdminLayout>
